import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropDiscordWidget(slug?: string) {
    return useQuery({
        queryKey: ["drop-discord-widget", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentDiscordWidget({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 5 * 60 * 1000,
    });
}
